export const styles = {
  container: {
    padding: '40px 20px',
    maxWidth: '900px',
    margin: '0 auto',
    backgroundColor: '#f8f9fa',
    minHeight: '100vh'
  },
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#333',
    textAlign: 'center',
    marginBottom: '30px',
    paddingBottom: '15px',
    borderBottom: '3px solid #28a745'
  },
  messageBox: {
    backgroundColor: '#d4edda',
    color: '#155724',
    padding: '20px',
    borderRadius: '8px',
    margin: '0 auto 30px',
    border: '1px solid #c3e6cb',
    maxWidth: '600px',
    textAlign: 'center',
    fontSize: '16px'
  },
  completionText: {
    fontSize: '16px',
    color: '#333',
    marginBottom: '15px',
    textAlign: 'center',
    lineHeight: '1.6'
  },
  memberInfoContainer: {
    backgroundColor: 'white',
    border: '1px solid #dee2e6',
    borderRadius: '8px',
    padding: '25px',
    marginBottom: '30px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },
  memberInfoTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#495057',
    marginBottom: '20px',
    borderBottom: '2px solid #007bff',
    paddingBottom: '10px'
  },
  memberInfoBox: {
    backgroundColor: '#f8f9fa',
    border: '1px solid #e9ecef',
    borderRadius: '6px',
    padding: '20px'
  },
  memberInfoItem: {
    marginBottom: '12px',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center'
  },
  memberInfoLabel: {
    fontWeight: 'bold',
    width: '120px',
    color: '#6c757d',
    flexShrink: 0
  },
  memberInfoValue: {
    color: '#495057',
    fontWeight: '600'
  },
  
  // 口座振替情報セクション
  paymentInfoSection: {
    marginBottom: '30px'
  },
  paymentInfoTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '25px',
    textAlign: 'center',
    borderBottom: '3px solid #007bff',
    paddingBottom: '15px'
  },
  bankTransferNotice: {
    backgroundColor: '#e8f5e8',
    border: '2px solid #4caf50',
    borderRadius: '8px',
    padding: '20px',
    marginBottom: '25px',
    textAlign: 'center'
  },
  noticeTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#2e7d32',
    marginBottom: '10px'
  },
  noticeText: {
    fontSize: '15px',
    color: '#388e3c',
    lineHeight: '1.5'
  },
  
  // ステップ表示
  stepsContainer: {
    marginBottom: '25px'
  },
  stepContainer: {
    backgroundColor: 'white',
    border: '2px solid #007bff',
    borderRadius: '8px',
    marginBottom: '20px',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
  },
  stepHeader: {
    backgroundColor: '#007bff',
    color: 'white',
    padding: '15px 20px',
    fontSize: '16px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  stepNumber: {
    backgroundColor: 'white',
    color: '#007bff',
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '14px',
    flexShrink: 0
  },
  stepTitle: {
    fontSize: '16px'
  },
  stepContent: {
    padding: '20px',
    backgroundColor: '#f8f9fa'
  },

  // 金額情報表示
  amountInfoContainer: {
    backgroundColor: '#fff3cd',
    border: '2px solid #ffc107',
    borderRadius: '8px',
    padding: '20px',
    marginBottom: '20px',
    textAlign: 'center'
  },
  amountTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#856404',
    marginBottom: '10px'
  },
  amountValue: {
    fontSize: '25px',
    fontWeight: 'bold',
    color: '#856404',
    marginBottom: '8px'
  },
  amountBreakdown: {
    fontSize: '14px',
    color: '#856404',
    fontWeight: '500'
  },
  
  // 銀行情報
  bankInfoContainer: {
    backgroundColor: 'white',
    border: '1px solid #dee2e6',
    borderRadius: '6px',
    padding: '20px',
    marginBottom: '15px'
  },
  bankInfoRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '12px',
    fontSize: '14px'
  },
  bankInfoLabel: {
    fontWeight: 'bold',
    width: '100px',
    color: '#495057',
    flexShrink: 0
  },
  bankInfoValue: {
    color: '#212529',
    fontWeight: '600',
    fontSize: '14px'
  },
  
  // 注意事項とリンク
  noteContainer: {
    backgroundColor: '#fff3cd',
    border: '1px solid #ffeaa7',
    borderRadius: '6px',
    padding: '15px',
    marginBottom: '15px'
  },
  noteText: {
    color: '#856404',
    fontSize: '13px',
    lineHeight: '1.5',
    margin: 0
  },
  procedureContainer: {
    backgroundColor: 'white',
    border: '1px solid #dee2e6',
    borderRadius: '6px',
    padding: '20px',
    marginBottom: '15px'
  },
  procedureText: {
    marginBottom: '15px',
    fontSize: '14px',
    lineHeight: '1.6',
    color: '#495057'
  },
  linkContainer: {
    backgroundColor: '#e7f3ff',
    border: '2px solid #007bff',
    borderRadius: '6px',
    padding: '15px',
    textAlign: 'center',
    marginBottom: '15px'
  },
  linkLabel: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#007bff',
    marginBottom: '8px',
    display: 'block'
  },
  link: {
    color: '#007bff',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 'bold',
    wordBreak: 'break-all'
  },
  warningContainer: {
    backgroundColor: '#f8d7da',
    border: '1px solid #f5c6cb',
    borderRadius: '6px',
    padding: '15px'
  },
  warningText: {
    color: '#721c24',
    fontSize: '13px',
    lineHeight: '1.5',
    margin: 0
  },
  
  // アクションボタン
  actionContainer: {
    textAlign: 'center',
    marginTop: '40px'
  },
  homeButton: {
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '15px 40px',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },
  homeButtonHover: {
    backgroundColor: '#218838',
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
  }
};